/** Order Management subcategories (PXM-1) */
// Phase 1 — selectable
export const ORDER_SUBCATEGORIES_PHASE1 = [
    'GENERAL',
    'DISTANCE_INQUIRY',
    'TECHNICIAN_NAME_REQUEST',
    'STATUS_INQUIRY',
];
// Phase 2 — selectable (with check filters for some)
export const ORDER_SUBCATEGORIES_PHASE2 = [
    'QUOTE',
    'MOVE_FTU',
    'MANUAL_PATCH',
    'MANUAL_DEPATCH',
    'AERIAL_TO_UNDERGROUND',
    'REMOVE_RESERVATION',
    'DAMAGE',
    // UTAC Swap — same field set as GENERAL (JVID lookup, no distance fields, no eligibility
    // gate) plus two OPTIONAL free-text UTACs. Deliberately NOT in UTAC_SUBCATEGORIES (it keeps
    // the JVID lookup) and NOT in CHECK_SUBCATEGORIES (no DMP gate). Never reaches order automation.
    'UTAC_SWAP',
    // Splitter Swap — "your documentation puts this JVID on the wrong splitter". Same field set as
    // GENERAL (JVID lookup, no distance fields, no eligibility gate) plus two MANDATORY splitter
    // references: splitterSwapFrom (what DMP records) and splitterSwapTo (reality). Like UTAC_SWAP,
    // deliberately NOT in UTAC_SUBCATEGORIES nor CHECK_SUBCATEGORIES.
    // ⚠️ Never reaches order automation: the hook in ticket.service.ts allow-lists MANUAL_PATCH /
    // MANUAL_DEPATCH only, and `utac` + `customerReference` stay NULL on these tickets — which is
    // the last line of defence, since executeAndPersist builds a CEASE from `utac` and a PATCH from
    // `customerReference`. Never store a swap reference in either of those columns.
    'SPLITTER_SWAP',
];
export const ORDER_SUBCATEGORIES = [
    ...ORDER_SUBCATEGORIES_PHASE1,
    ...ORDER_SUBCATEGORIES_PHASE2,
];
/**
 * Retired from the pickers: still a valid value on existing rows, still accepted by the create
 * and filter APIs, just never offered as a new UI choice. Render-side only — ORDER_SUBCATEGORIES
 * stays complete, because the backend, the Public API enum and existing tickets all need it.
 * MOVE_FTU was retired from the creation wizard in v1.7.0; 14 production tickets still carry it.
 */
export const RETIRED_ORDER_SUBCATEGORIES = ['MOVE_FTU'];
/**
 * What a user may pick today — the creation wizard's tiles AND the ticket list's Category filter.
 * Both derive from this one list so they can never drift apart.
 */
export const SELECTABLE_ORDER_SUBCATEGORIES = ORDER_SUBCATEGORIES.filter((s) => !RETIRED_ORDER_SUBCATEGORIES.includes(s));
/** Subcategories that use UTAC input instead of JVID */
export const UTAC_SUBCATEGORIES = ['MANUAL_DEPATCH', 'MOVE_FTU'];
/** Subcategories that require an eligibility check against DMP */
export const CHECK_SUBCATEGORIES = ['QUOTE', 'MANUAL_PATCH', 'MANUAL_DEPATCH', 'MOVE_FTU'];
/** Move FTU reason values */
export const MOVE_FTU_REASONS = ['TECHNICAL', 'COSMETIC', 'OTHER'];
//# sourceMappingURL=order-subcategories.js.map